/**
 * reCAPTCHA v3 token collection for the portal page.
 *
 * The v3 script is loaded by home/template/v2/homeTemplateV2.jsp and the site key is passed through on
 * the mount element, so it is not duplicated here. Mirrors the call registration already makes
 * (home/template/v2/register.jsp).
 */

const RECAPTCHA_TIMEOUT_MS = 5000;

let siteKey = null;

export const setRecaptchaSiteKey = (key) => {
    siteKey = key;
};

/**
 * Resolves to a token, or to null when reCAPTCHA is unavailable. Never rejects: the caller still
 * submits, and the server decides whether a missing token is acceptable.
 */
export const getRecaptchaToken = (action) => new Promise((resolve) => {
    if (!siteKey || typeof window.grecaptcha === 'undefined' || !window.grecaptcha.ready) {
        resolve(null);
        return;
    }

    // Don't let a slow or blocked reCAPTCHA hang the form.
    const timeout = setTimeout(() => resolve(null), RECAPTCHA_TIMEOUT_MS);

    try {
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(siteKey, {action})
                .then((token) => {
                    clearTimeout(timeout);
                    resolve(token);
                })
                .catch(() => {
                    clearTimeout(timeout);
                    resolve(null);
                });
        });
    } catch (error) {
        clearTimeout(timeout);
        resolve(null);
    }
});
